/* eslint-disable no-unused-vars */
// CSS
import Alpine from "alpinejs";

Alpine.data("dropdown", () => ({
  open: false,

  toggle() {
    if (this.open) {
      return this.close();
    }
    this.$refs.button.focus();
    this.open = true;
  },

  close(focusAfter) {
    if (!this.open) return;
    this.open = false;
    focusAfter && focusAfter.focus();
  },
}));

Alpine.data("vehicles", () => ({
  init() {
    this.getArticleCount();
  },
  allCategories: [],
  selectedCategories: [],
  sortOptions: [
    {
      name: "Sort by Newest",
      query: "postDate DESC",
    },
    {
      name: "Sort by Oldest",
      query: "postDate ASC",
    },
  ],
  sortSelection: `Sort by Newest<span class="material-icons-round">expand_more</span>`,
  sortQuery: "postDate DESC",
  articles: [],
  articleCount: 0,
  currentPage: 1,
  lastPage: 0,
  offSet: 0,
  searchTerm: "*",
  pageSize: 8,
  pageLinks: [],
  showLoader: "hidden",

  scrollToListTop() {
    this.$refs.listTop.scrollIntoView({ block: "start" });
  },

  prevPage() {
    this.currentPage -= 1;
    this.offSet -= this.pageSize;
    this.getArticles();
    this.getPageLinks();
    this.scrollToListTop();
  },
  nextPage() {
    this.currentPage += 1;
    this.offSet += this.pageSize;
    this.getArticles();
    this.getPageLinks();
    this.scrollToListTop();
  },

  goToPage(page) {
    this.offSet = this.pageSize * (page - 1);
    this.currentPage = page;
    this.getPageLinks();
    this.getArticles();
    this.scrollToListTop();
  },

  getPageLinks() {
    const allLinks = [...Array(this.lastPage).keys()].map((el) => el + 1);
    if (this.lastPage <= 4) {
      this.pageLinks = allLinks;
    } else {
      const alwaysDisplay = [
        1,
        this.lastPage,
        this.currentPage,
        this.currentPage + 1,
        this.currentPage - 1,
      ];
      const pageLinkArray = allLinks.filter((link) => {
        if (alwaysDisplay.includes(link)) return link;
      });
      this.pageLinks = pageLinkArray;
    }
  },

  addClasses(page) {
    if (page === this.currentPage) return "current-page";
    if (this.lastPage > 4) {
      if (page === this.currentPage + 1 && page + 2 <= this.lastPage)
        return "ellipsis_after";
      if (page === 1 && this.currentPage > 3) return "ellipsis_after";
    }
  },

  setCategories(data) {
    const allCategories = data.reduce((arr, item) => {
      arr.push(item.title);
      return arr;
    }, []);
    this.allCategories = allCategories;
    this.selectedCategories = allCategories;
  },
  setSortSelection(selection) {
    this.close();
    this.sortQuery = this.sortOptions.find((option) => {
      return option.name === selection;
    }).query;
    this.sortSelection = `${selection}<span class="material-icons-round">expand_more</span>`;
    this.getArticles();
  },
  /**
   * Returns a string to represent the count of results.
   */
  getResultsCountBlurb() {
    if (this.articleCount >= this.pageSize) {
      let endRange = this.offSet + this.pageSize;
      if (endRange > this.articleCount) {
        endRange = this.articleCount;
      }
      return `Showing ${this.offSet + 1} to ${endRange} of ${
        this.articleCount
      } articles.`;
    } else if (this.offSet + this.pageSize > this.articleCount) {
      return `Showing ${this.offSet + 1} to ${this.articleCount} of ${
        this.articleCount
      } articles.`;
    }
    return `Showing ${this.articleCount} articles`;
  },
  getCheckedCategory(cat) {
    const iconClass = this.selectedCategories.includes(cat)
      ? "check_box"
      : "check_box_outline_blank";
    return `
      <span class="material-icons-round align-baseline">${iconClass}</span>
      <span class="block">${cat}</span>
      `;
  },
  toggleChecked(cat) {
    if (this.selectedCategories.includes(cat)) {
      this.selectedCategories = this.selectedCategories.filter((item) => {
        return item != cat;
      });
    } else {
      this.selectedCategories.push(cat);
    }
    this.getArticleCount();
    this.goToPage(1);
  },

  /**
   * Spinning Loader
   */
  initialRenderStillPresent: true,
  clearInitial() {
    if (this.initialRenderStillPresent) {
      this.$refs.initial.remove();
      this.initialRenderStillPresent = false;
    }
  },

  /**
   * API Calls
   */
  async getArticles() {
    this.showLoader = "visible";
    const query = `
      query ($search: String, $order: String, $pageSize: Int, $offSet: Int, $filters: [String]) {
        entries(
          search: $search
          section: "vehicleArticles"
          limit: $pageSize
          offset: $offSet
          orderBy: $order
          relatedToCategories: {group: "vehicleMakes", title: $filters}
          ) {
            title
            uid
            url
            postDate @formatDateTime(format: "M d, Y")
            ... on vehicleArticles_vehicleArticle_Entry {
              description
              vehicleImages(limit: 1) {
                title
                url(transform: "smallPortraitThumbnail")
              }
            }
        }
      }`;
    const variables = {
      order: this.sortQuery,
      filters: this.selectedCategories,
      pageSize: this.pageSize,
      offSet: this.offSet,
      search: this.searchTerm,
    };

    fetch("/api", {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer m0624oThl9zQDhw9Q3Zsahau1EzlOaj8",
      },
      body: JSON.stringify({ query, variables }),
    })
      .then((res) => res.json())
      .then((result) => {
        const newData = result.data.entries.reduce((arr, item) => {
          let newCleaned = {};
          let imageUrl = "";
          if (item.vehicleImages.length) {
            imageUrl = item.vehicleImages[0].url;
          }
          newCleaned = {
            id: item.uid,
            date: item.date,
            description: item.description,
            url: item.url,
            title: item.title,
            postDate: item.postDate,
            imageUrl: imageUrl,
          };
          arr.push(newCleaned);
          return arr;
        }, []);
        this.clearInitial();
        this.articles = newData;
        this.showLoader = "hidden";
      })
      .catch((error) => console.log(error));
  },
  async getArticleCount() {
    const query = `query ($filters: [String]) {
      entryCount(
        section: "vehicleArticles"
        relatedToCategories: {group: "vehicleMakes", title: $filters}
      )
    }
    `;
    const variables = {
      filters: this.selectedCategories,
    };

    fetch("/api", {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer m0624oThl9zQDhw9Q3Zsahau1EzlOaj8",
      },
      body: JSON.stringify({ query, variables }),
    })
      .then((res) => res.json())
      .then((result) => {
        this.articleCount = result.data.entryCount;
        this.lastPage = Math.ceil(this.articleCount / this.pageSize);
        this.getPageLinks();
      })
      .catch((error) => console.log(error));
  },
}));

Alpine.start();
